export default (key) => {
    return sessionStorage.setItem('app_key', key)
}